// extracted by mini-css-extract-plugin
export default {"header-contact-us":"styles-module__header-contact-us___qpMGj","icon":"styles-module__icon___blBtb","text":"styles-module__text___vKQU3"};